import React, { useEffect, useState } from 'react';
import { useTranslate } from '../../lib'
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import ButtonYesNo from '../common/ButtonYesNo'
import { SelectNesting } from '../common/Inputs/Select'
import { TextareaNesting } from '../common/Inputs/Input'
import axios from "axios";

export default function WizardStep6({ 
  formData, 
  setFormData, 
  refs,
  voices,
  setAlert
}) {
  const { t } = useTranslate();
  const [textToPlay, setTextToPlay] = useState('')
  const [showClosing, setShowClosing] = useState(false)

  const playVoice = async () => {
    const selectedVoiceId = refs.voice_ref.current?.value;
    const selectedVoice = voices.find(v => String(v.id) === String(selectedVoiceId));
    let voice = selectedVoice?.voice;
    if (!voice) {
        setAlert({ title: 'Select a valid voice', visible: true, error: true });
        return;
    }

    try {
        let url = `${process.env.REACT_APP_AZURE_ENDPOINT}/sts/v1.0/issuetoken`;
        const resToke = await axios.post(url, {}, {
            headers: {
                'Ocp-Apim-Subscription-Key': process.env.REACT_APP_AZURE_SUBCRIPTION_KEY
            }
        });
        let token = resToke.data;

        const pitch = '0%';
        const style = 'general';
        const rate = '0%';
        const volume = '+0.00%';
        if (textToPlay.trim() !== '') {
            let speaker1 = `<speak version="1.0" xmlns="http://www.w3.org/2001/10/synthesis" 
                            xmlns:mstts="https://www.w3.org/2001/mstts" xml:lang="en-US">
                                  <voice name="${voice?.trim()?.replaceAll('_', '-')}">
                                      <prosody rate="${rate}" pitch="${pitch}" volume="${volume}">
                                          <mstts:express-as style="${style}">
                                              ${textToPlay}
                                          </mstts:express-as>
                                      </prosody>
                                  </voice>
                               </speak>`;
            try {
                const res3 = await fetch('https://eastus.tts.speech.microsoft.com/cognitiveservices/v1', {
                    method: 'POST',
                    headers: {
                        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_AZURE_SUBCRIPTION_KEY,
                        Authorization: `Bearer ${token}`,
                        'cache-control': 'no-cache',
                        'X-Microsoft-OutputFormat': 'riff-24khz-16bit-mono-pcm',
                        'Content-Type': 'application/ssml+xml'
                    },
                    body: speaker1
                });
                if (!res3.ok) {
                    throw new Error('Fetch failed!');
                }
                const wavFile = await res3.blob();
                const audioUrl = URL.createObjectURL(wavFile);
                const audio = new Audio(audioUrl);
                audio.play();
            } catch (error) {
                setAlert({ title: 'Error playing voice', visible: true, error: true });
                console.log(error);
            }
        } else {
            setAlert({ title: 'Write a text to play', visible: true, error: true });
        }
    } catch (error) {
        setAlert({ title: 'Error getting Azure token', visible: true, error: true });
        console.log(error);
    }
  }

  useEffect(() => {
    console.log("Ingreso a closing", formData.maximum_call_durations, formData.maximum_call_durations != 0)
    setShowClosing(formData.maximum_call_durations != 0)
  }, []);

  return (
    <div className="wizard-step">
      <h2 className="mb-4" style={{ color: '#0B5FA3', fontSize: 20 }}>
        {t('menu.genai.voicesSettings')}
      </h2>

      <div className="p-0-mb flex flex-col flex-1 mt-2" style={{ paddingRight: 20, paddingLeft: 20 }}>

      <div className="flex flex-row items-center mt-2">
          <div className="input">
            <div className='d-flex flex-row align-items-center w-100' style={{ width: "350px" }}>
              <div className="flex items-center mr-4" style={{ marginBottom: "2%" }}>
                <span className='label-select' style={{ minWidth: 140 }}>{t('menu.genai.transcriptionEnable')}:</span>
                <img id="transcription-tp" src="/icons/tooltip-indicator-icon.svg" className="ml-3 cursor-pointer tooltip-nesting" alt="" />
                <Tooltip openOnClick={true} anchorSelect="#transcription-tp"
                  html={t('menu.genai.transcriptionEnableTooltip')} place="top" />
              </div>
              <ButtonYesNo
                onClick={() => setFormData({ ...formData, transcription: !formData.transcription })}
                width={150}
                state={formData.transcription}
                height={30}
              />
            </div>
          </div>
        </div>
        
        
        <div className="flex flex-row items-center mt-2">
          <div className="input">
            <div className='d-flex flex-row align-items-center w-100' style={{ width: "350px" }}>
              <div className="flex items-center mr-4" style={{ marginBottom: "2%", marginRight: 20 }}>
                <span className='label-select' holdAttempts>{t('menu.genai.onHoldAvailability')}:</span>
                <img id="hold-tp" src="/icons/tooltip-indicator-icon.svg" className="ml-3 cursor-pointer tooltip-nesting" alt="" />
                <Tooltip openOnClick={true} anchorSelect="#hold-tp"
                  html={t('menu.genai.onHoldAvailabilityTooltip')} place="top" />
              </div>
              <ButtonYesNo
                onClick={() => setFormData({ ...formData, hold: !formData.hold })}
                width={150} zIndex='0'
                state={formData.hold}
                height={30}
              />
            </div>
          </div>
        </div>

        <div className="flex flex-row items-center mt-2">
          <div className="inputs">
            <div className="input">
              <div className='d-flex flex-column w-100'>
                <div className="d-flex flex-row align-items-center mt-2">
                  <span style={{ fontSize: 14 }}>{t('menu.genai.holdAttempts')}:</span>
                  <img id="hold-attempts-tp" src="/icons/tooltip-indicator-icon.svg" className="ml-2 cursor-pointer tooltip-nesting" alt="" />
                  <Tooltip openOnClick={true} anchorSelect="#hold-attempts-tp"
                    html={t('menu.genai.holdAttemptsTooltip')} place="top" />
                  <input style={{ maxWidth: 113, marginRight: 5 }}
                    ref={refs.timeHoldAmountRef}
                    className='input-data'
                    disabled={!formData.hold}
                    onChange={(e) => setFormData({ ...formData, time_hold_amount: e.target.value })} 
                    defaultValue={formData.time_hold_amount}
                    type="number"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="inputs">
            <div className="input">
              <div className='d-flex flex-column'>
                <div className="d-flex flex-row align-items-center mt-2">
                  <span style={{ fontSize: 14 }}>{t('menu.genai.holdTime')}:</span>
                  <img id="hold-time-tp" src="/icons/tooltip-indicator-icon.svg" className="ml-1 cursor-pointer tooltip-nesting" alt="" />
                  <Tooltip openOnClick={true} anchorSelect="#hold-time-tp" className='ml-3'
                    html={t('menu.genai.holdTimeTooltip')} place="top" />
                  <input style={{ maxWidth: 113 }}
                    ref={refs.timeHoldRef}
                    className='input-data'
                    disabled={!formData.hold}
                    onChange={(e) => setFormData({ ...formData, time_hold: e.target.value })} 
                    defaultValue={formData.time_hold}
                    type="number"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-row items-center mt-3">
          <div className="inputs">
            <div className="input">
              <div className='d-flex flex-row align-items-center'>
                <span>{t('menu.genai.minimunCallDurations')}:</span>
                <img id="min-call-duration-tp" src="/icons/tooltip-indicator-icon.svg" className="ml-1 cursor-pointer tooltip-nesting" alt="" />
                <Tooltip openOnClick={true} anchorSelect="#min-call-duration-tp"
                  html={t('menu.genai.minimunCallDurationsTooltip')} place="top" />
                <input style={{ maxWidth: 100, marginRight: 5 }}
                  ref={refs.minimunCallDurations}
                  className='mt-1 input-data'
                  type="number"
                  onChange={(e) => setFormData({ ...formData, minimum_call_durations: e.target.value })} 
                  defaultValue={formData.minimum_call_durations}
                />
              </div>
            </div>
          </div>
          <div className="inputs">
            <div className="input">
              <div className='d-flex flex-row align-items-center'>
                <span>{t('menu.genai.maximunCallDurationsVoice')}</span>
                <img id="max-call-duration-tp" src="/icons/tooltip-indicator-icon.svg" className="ml-1 cursor-pointer tooltip-nesting" alt="" />
                <Tooltip openOnClick={true} anchorSelect="#max-call-duration-tp"
                  html={t('menu.genai.maximunCallDurationsTooltip')} place="top" />
                <input style={{ maxWidth: 100 }}
                  ref={refs.maximunCallDurations}
                  className='mt-1 input-data'
                  type="number"
                  onChange={(e) => {
                    setFormData({ ...formData, maximum_call_durations: e.target.value })
                    setShowClosing(e.target.value != 0)
                  }}
                  defaultValue={formData.maximum_call_durations}
                />
              </div>
            </div>
          </div>
        </div>

        { showClosing &&
          <div className="d-flex flex-row mt-2">
            <TextareaNesting
              containerClass="mr-2 mb-2" style={{ flexGrow: '1', minWidth: 850 }}
              id="closing_mesage"
              type="text"
              row={2.5}
              title= {t('menu.genai.closingCallMessage')}
              onChange={(e) => setFormData({ ...formData, closing_msg: e.target.value })} 
              defaultValue={formData.closing_msg}
            />
          </div>
        }

        <div className="flex flex-row items-center mt-1">
          <div className="inputs mt-3">
            <div className="input">
              <div className='d-flex flex-col w-100 mr-3' style={{ alignItems: "center", flexDirection: "row" }}>
                <div className='d-flex flex-row align-items-center' style={{ marginRight: 10 }}>
                  <span className='label-select'>{t('menu.genai.randomVoices')}:</span>
                  <img id="random-voices" src="/icons/tooltip-indicator-icon.svg" className="ml-2 cursor-pointer tooltip-nesting" alt="" />
                  <Tooltip openOnClick={true} anchorSelect="#random-voices"
                    html={t('menu.genai.randomVoicesTooltip')} place="top" />
                </div>
                <ButtonYesNo
                  onClick={() => setFormData({ ...formData, radomVoice: !formData.radomVoice })}
                  width={150}
                  state={formData.radomVoice}
                  height={30}
                />
              </div>
            </div>
          </div>

          <div className="inputs mt-3" style={{marginLeft: 20}}>
            <div className="input">
              <div className="d-flex flex-row align-items-center justify-space-between w-100">
                <div className='d-flex flex-row align-items-center'>
                  <span>{t('menu.genai.selectVoice')}:</span>
                  <img id="select-voice" src="/icons/tooltip-indicator-icon.svg" className="ml-2 cursor-pointer tooltip-nesting" alt="" />
                  <Tooltip openOnClick={true} anchorSelect="#select-voice"
                    html={t('menu.genai.selectVoiceTooltip')} place="top" />
                </div>
                <select ref={refs.voice_ref} className='select ml-2 select-nesting input-data' 
                  style={{ flexGrow: '2', backgroundPositionX: "96%" }}
                  id="voice"
                  onChange={(e) => setFormData({ ...formData, voice_id: e.target.value })} 
                  defaultValue={formData.voice_id}>
                  <option disabled selected>{t('menu.genai.selectVoiceOption')}</option>
                  {voices.map((item, index) => (
                    <option key={index} value={item.id}>{item.voice}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-row items-center">
          <div className="inputs mt-3">
            <div className="input">
              <div className='d-flex flex-col w-100 mr-3' style={{ alignItems: "center", flexDirection: "row" }}>
                <input
                  type="text"
                  className="input-data"
                  style={{ minWidth: 250, maxWidth: 400 }}
                  placeholder="Write the text to be played"
                  value={textToPlay}
                  onChange={e => setTextToPlay(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className="inputs mt-3" style={{marginLeft: 10}}>
            <div className="input">
              <div className="d-flex flex-row align-items-center justify-space-between w-100">
              <button className="btn-nesting ml-3 mr-3" type="button" 
              onClick={() => { playVoice() }}
              > {t('common.play')} </button>
              </div>
            </div>
          </div>
        </div>
        
        
        <div className='mt-3 d-flex flex-row flex-wrap align-items-center w-100'>
            <SelectNesting
              ref={refs.sentimentBotRef} 
              id="bot_sentiment" 
              onChange={(e) => setFormData({ ...formData, bot_sentiment: e.target.value })}
              defaultValue={formData.bot_sentiment}
              boxInfo={true} tooltipText={t('menu.genai.botSentimentTooltip')}
              title={t('menu.genai.botSentiment')} containerClass="" style={{ minWidth: 150 }}
            >
              <option value="1">{t('common.on')}</option>
              <option value="0">{t('common.off')}</option>
            </SelectNesting>
            <SelectNesting
              ref={refs.modelSentiment_ref} 
              id="model_sentiment"
              boxInfo={true} tooltipText={t('menu.genai.botSentimentTooltip')}
              title={t('menu.genai.modelSentiment')} containerClass="mt-10px-mb mr-2 ml-3" style={{ minWidth: 150 }}
              onChange={(e) => setFormData({ ...formData, model_sentiment: e.target.value })}
              defaultValue={formData.model_sentiment}
            >
              <option key={`model0`} value={'Phrase'}>{t('common.phrase')}</option>
              <option key={`model1`} value={'Voice'}>{t('common.voice')}</option>
              <option key={`model2`} value={'Both'}>{t('common.bothPhraseVoice')}</option>
            </SelectNesting>
          </div>
      </div>
    </div>
  );
}
